export const faqItems = [
  {
    id: "faq-1",
    question: "What is a Kakobuy Spreadsheet?",
    answer: "A Kakobuy Spreadsheet is an organized product directory that helps shoppers discover products quickly, compare prices, and save time while browsing. Instead of searching manually across multiple pages, users can browse categorized products, compare different options side by side, and find useful buying information all in one place.",
  },
  {
    id: "faq-2",
    question: "How often is the Kakobuy Spreadsheet updated?",
    answer: "The Kakobuy Spreadsheet is updated daily to ensure all product listings, prices, and availability information remain current. Our team regularly reviews and refreshes the product data so you always have access to the latest offerings and trending items across all categories.",
  },
  {
    id: "faq-3",
    question: "Is the Kakobuy Spreadsheet free to use?",
    answer: "Yes, the Kakobuy Spreadsheet is completely free to browse and use. There are no hidden fees or subscription requirements. Simply visit the website, explore the categories that interest you, and click through to find the products you are looking for at the best available prices.",
  },
  {
    id: "faq-4",
    question: "How do I find specific products in the Kakobuy Spreadsheet?",
    answer: "You can find products by browsing through our organized category sections on the homepage or using the category dropdown menu at the top of the page. Each category contains curated product listings with detailed information, making it easy to locate exactly what you need without endless scrolling.",
  },
  {
    id: "faq-5",
    question: "Is the Kakobuy Spreadsheet safe and reliable?",
    answer: "Absolutely. The Kakobuy Spreadsheet prioritizes user safety by carefully curating product listings from reputable sources. We provide transparent product information, honest comparisons, and helpful buying guides to ensure you can shop with confidence and make informed purchasing decisions.",
  },
  {
    id: "faq-6",
    question: "Can beginners use the Kakobuy Spreadsheet easily?",
    answer: "Yes, the Kakobuy Spreadsheet is designed to be beginner-friendly with a clean, intuitive interface. New users can quickly understand how to navigate categories, compare products, and find what they are looking for. We also provide helpful guides and tips to make the shopping experience smooth and enjoyable.",
  },
];